import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import Button from "@vfuk/core-button/dist/Button";
import Image from "@vfuk/core-image";
import Spacing from "@vfuk/core-spacing";

import successTick1x from "../../assets/images/successTick@1x.png";
import successTick2x from "../../assets/images/successTick@2x.png";
import successTick3x from "../../assets/images/successTick@3x.png";
import "../../assets/styles/common.scss";
import "../../assets/styles/common.scss";
import classes from "./SuccessModalContent.module.scss";

export type SuccessModalContentProps = {
  heading: string;
  body: string | ReactNode;
  confirmText: string;
  isOpen?: boolean;
  onConfirm: () => void;
  onClose?: () => void;
  cancelText?: string;
};

export const SuccessModalContent = ({
  heading,
  body,
  confirmText,
  onConfirm,
  onClose,
  cancelText,
}: SuccessModalContentProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div className={classes.SuccessContents} role="dialog">
      <div className={classes.successTick}>
        <Image
          alt={t("shared:users:alt_message")}
          sm={{
            src: successTick1x,
            srcSet: {
              x1: successTick1x,
              x2: successTick2x,
              x3: successTick3x,
            },
          }}
        />
      </div>
      <div className="modalMessage">{heading}</div>
      <Spacing spacingLevel={{ top: 4, left: 7, right: 7, bottom: 7 }}>
        <div className="modalSubmessage">{body}</div>
      </Spacing>
      <div className={classes.Buttons}>
        <div className={(classes.Button, classes.cancelButton)}>
          <Button width="full" text={confirmText} onClick={onConfirm} />
        </div>

        {cancelText && (
          <div className={(classes.Button, classes.confirmButton)}>
            <Button
              width="full"
              text={cancelText || ""}
              onClick={onClose}
              appearance="alt1"
            />
          </div>
        )}
      </div>
    </div>
  );
};
